<template>
  <div class="template-preview">
    <div
      v-if="template && template.devices"
      class="devices"
    >
      <el-button-group>
        <el-button
          v-if="template.devices.includes('mobile')"
          type="primary"
          size="mini"
          @click="$router.replace({ query: { device: 'mobile'} })"
        >
          <span class="iconfont">&#xe60d;</span>
        </el-button>
        <el-button
          v-if="template.devices.includes('pad')"
          type="primary"
          size="mini"
          @click="$router.replace({ query: { device: 'pad'} })"
        >
          <span class="iconfont">&#xe735;</span>
        </el-button>
        <el-button
          v-if="template.devices.includes('pc')"
          type="primary"
          size="mini"
          @click="$router.replace({ query: { device: 'pc'} })"
        >
          <span class="iconfont">&#xe663;</span>
        </el-button>
      </el-button-group>
    </div>

    <iframe
      class="preview"
      :class="{ mobile: device === 'mobile', pad: device === 'pad', pc: device === 'pc' }"
      :src="!!template ? template.httpUrl: ''"
      frameborder="0"
    />
  </div>
</template>

<style lang="less" scoped>
// 控制层高度
@controls-height: 45px;
// 间隙
@gap-height: 15px;

@template-cover-width: 200px;
@template-cover-height: 112.3px;

.controls {
  min-height: @controls-height;
  line-height: @controls-height;
  margin-bottom: @gap-height;
}
.template-preview {
  .preview {
    display: block;
    margin: 0 auto;
    border: none;
  }

  .mobile {
    width: 375px;
    height: 667px;
  }

  .pad {
    width: 768px;
    height: 1024px;
  }

  .pc {
    width: 1024px;
    height: 1366px;
  }
}
</style>

<script>
const debug = require('debug')('ccs:ctrl:template_preview');
import axios from 'axios';

export default {
	data() {
		return {
			device: 'mobile',
			version: 'latest',
			templateId: null,
			template: null
		};
	},
  
	watch: {
		// 如果路由有变化，会再次执行该方法
		$route: 'init'
	},
	async created() {
		await this.init();
	},

	methods: {
		async init() {
			const { templateId } = this.$route.params;
			const { device = 'mobile', version = 'latest' } = this.$route.query;
			const template = await axios.get(`/api/templates/${templateId}`, {
				params: { version }
			});

			debug(
				'[init] templateId: %s, device: %s, version: %s, template: %o',
				templateId,
				device,
				version,
				template
			);

			this.templateId = templateId;
			this.device = device;
			this.version = version;
			this.template = template;
		}
	}
};
</script>
